export default __webpack_public_path__ + "static/basecamp-a47f2977196bd5b2ef258c8040a950ad.svg";